import I18n from 'i18n-js';
import eyeson from '@eyeson/js';
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MessageParser from './MessageParser.js';
import dateHelper from '../../../../utils/dateHelper.js';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { createOverlayFromText } from '../../../../utils/OverlayHelper.js';
import supports from '../../../../utils/SupportHelper.js';
import CopyMessageButton from './CopyMessageButton.js';

class QuestionMessage extends Component {
  state = { shared: false };

  handleClick = async () => {
    if (this.state.shared) {
      this.props.onEvent({ type: 'clear_front_layer' });
    } else {
      try {
        const { comApi } = eyeson.core;
        const width = 1280;
        const height = eyeson.options.widescreen ? 720 : 960;
        const blob = await createOverlayFromText(
          `${this.props.user.name}:`,
          this.content.substr(0, 281),
          width,
          height
        );
        const formData = new FormData();
        formData.set('file', blob, 'ask.png');
        formData.set('z-index', '1');
        await fetch(`${comApi.uri}/rooms/${comApi.token}/layers`, {
          method: 'POST',
          body: formData,
        });
      } catch (error) {
        console.warn('QuestionMessage::createOverlay', error);
      }
    }
    this.setState({ shared: !this.state.shared });
  };

  /**
   * A question message starts with "/ask ".
   **/
  static test(props) {
    return props.content.substr(0, 5) === '/ask ';
  }

  get content() {
    return this.props.content.replace('/ask ', '');
  }

  /**
   * Render a message that describes a question.
   **/
  render() {
    return (
      <div className="eyeson-chat-message question">
        <div className="chat-avatar-wrap">
          <span className="icon-wrap icon-wrap__question">
            <Icon className="icon-question">live_help</Icon>
          </span>
          {supports.ClipboardAPI && (
            <CopyMessageButton
              content={this.content}
              onEvent={this.props.onEvent}
            />
          )}
        </div>
        <div className="content">
          <div className="content-wrap">
            <span className="details">
              <strong className="username">{this.props.user.name}</strong>
              <span className="date">
                {dateHelper.formatTime(this.props.timestamp)}
              </span>
            </span>
            <MessageParser>{this.content}</MessageParser>
          </div>
        </div>
        <Tooltip
          title={
            this.state.shared
              ? I18n.t('label:clear_from_stream')
              : I18n.t('label:show_in_stream')
          }
          placement="top"
        >
          <IconButton
            className="chat-message-button__flex-center"
            onClick={this.handleClick}
          >
            <Icon title="Show">
              {this.state.shared ? 'visibility_off' : 'visibility'}
            </Icon>
          </IconButton>
        </Tooltip>
      </div>
    );
  }
}

QuestionMessage.propTypes = {
  user: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
};

export default QuestionMessage;
